<template>
    <div>
        <fieldset>
            <div class="row">
                <legend>Eligible Eyecare Professional Evaluation Product Information</legend>
            </div>
            <div class="row">
                <div class="small-6 columns lp">
                  <labeled-input label="First Name *" name="First Name" validation="required|max:20|regex:^[a-zA-Z]+([a-zA-Z]+)*$" v-model='sampleobject.firstName'></labeled-input>
                </div>
                <div class="small-6 columns lp">
                    <labeled-input label="Last Name *" name="Last Name" validation="required|max:20|regex:^[a-zA-Z]+([a-zA-Z]+)*$" v-model='sampleobject.lastName'></labeled-input>
                </div>
            </div>
            <div class="row">
                <div class="small-12 columns lp">
                    <labeled-input label="Practice Name *" name="Practice Name" v-model='sampleobject.practiceName'></labeled-input>
                </div>
            </div>
            <div class="row">
                <div class="small-12 columns lp">
                    <div class="medium-6 columns lp">
                        <div :class="{'error': errors.has('Role') }">
                            <label for="role">Role at Practice *</label>
                            <select v-validate data-vv-rules="required" v-model="role" name="Role" id="role" class="orderinput-select">
                                <!-- <option selected value> </option> -->
                                <option value="Optician">Optician</option>
                                <option value="Optometrist">Optometrist</option>
                                <option value="Ophthalmologist">Ophthalmologist</option>
                                <option value="Technician">Optical Technician</option>
                                <!-- <option value="Office Manager">Office Manager</option>
                                <option value="Practice Owner">Practice Owner</option> -->
                                <option value="Eyewear Consultant">Eyewear Consultant</option>
                                <!-- <option value="Other">Other</option> -->
                            </select>
                            <p class="error" v-if="errors.has('Role')">{{ errors.first('Role') }}</p>
                        </div>
                    </div>
                    <!--<div class="medium-6 columns 1p">
                        <div v-if="showOther" :class="{'error': errors.has('Role (Other)') }">
                            <label for="roleOther">If other, your Role *</label>
                            <input id="roleOther" type="text" v-validate="'required'" name="Role (Other)" class="full-txt" placeholder="" v-model='roleOther'>
                            <p class="error" v-if="errors.has('Role (Other)')">Role is required</p>
                        </div>
                    </div>-->
                </div>
                <div class="small-12 columns lp">
                    <labeled-input label="Current Lens Worn *" name="Current Lens Worn" v-model='sampleobject.currentLens'></labeled-input>
                </div>
            </div>
        </fieldset>
    </div>
</template>
<script>
import LabeledInput from "@/components/shared/LabeledInput";

export default {
  props: ["selected", "sampleobject"],
  inject: ["$validator"],
  components: { LabeledInput },
  data() {
    return {
      role: "",
      roleOther: ""
    };
  },
  watch: {
    // whenever question changes, this function will run
    role() {
      this.sampleobject.role =
        this.role == "Other" ? this.roleOther : this.role;
    },
    roleOther() {
      this.sampleobject.role =
        this.role == "Other" ? this.roleOther : this.role;
    }
  },

  computed: {
    showOther() {
      return this.role == "Other";
    }
  },
  created() {
    var selectedRole = this.sampleobject.role;
    var roles = [
      "Optician",
      "Optometrist",
      "Ophthalmologist",
      "Technician",
      "Office Manager",
      "Practice Owner",
      "Eyewear Consultant"
    ];
    if (!selectedRole) {
      return;
    }
    for (let r of roles) {
      if (selectedRole == r) {
        this.role = r;
        this.roleOther = "";
      }
    }
    //this.role = "Other";
    //this.roleOther = selectedRole;
  },
};
</script>
